import { Controller } from 'stimulus'

/**
 * Manages javascript for disabling/re-enabling autocompletion for fields
 *
 * @class AutocompleteController
 * @memberof Controllers
 * @extends {Controller}
 */
export default class extends Controller {
  /**
   * @function controllers.AutocompleteController.disable
   * @memberof controllers
   * @description disables the browser autocomplete functionality for an input
   *
   * @param {event} event
   * @return {undefined} manipulates the dom
   */
  disable(event) {
    event.target.setAttribute('autocomplete', 'new-password')
  }

  /**
   * @function controllers.AutocompleteController.enable
   * @memberof controllers
   * @description re-enables the browser autocomplete functionality for an input
   *
   * @param {event} event
   * @return {undefined} manipulates the dom
   */
  enable(event) {
    event.target.removeAttribute('autocomplete')
  }
}
